module.exports = __webpack_public_path__ + "static/media/pepfuels_color.0dbfb6d7.jpg";